import { Pipe, PipeTransform } from '@angular/core';

export type ZonedFormatMode = 'time' | 'date' | 'datetime';
export type ZonedFormatTzName = 'short' | 'long';

@Pipe({
  name: 'zonedDateTime',
  standalone: true,
})
export class ZonedDateTimePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    mode: ZonedFormatMode = 'time',
    format: ZonedFormatTzName = 'short'
  ): string {
    if (!value) return '';

    // API returns an iso zoned date time string, pull out our timezone ID - 2026-09-08T14:32:53-06:00[America/Denver]
    const tzMatch = value.match(/\[(.*?)\]/);
    const tzId = tzMatch ? tzMatch[1] : undefined;

    const isoStringTrimmed = value.replace(/\[.*?\]/, '');
    const date = new Date(isoStringTrimmed);

    // Make sure this is a valid date time, if not just return what was passed
    if (isNaN(date.getTime())) return value;

    const options: Intl.DateTimeFormatOptions = {
      timeZone: tzId,
    };

    if (mode === 'date' || mode === 'datetime') {
      options.year = 'numeric';
      options.month = '2-digit';
      options.day = '2-digit';
    }

    if (mode === 'time' || mode === 'datetime') {
      options.hour = '2-digit';
      options.minute = '2-digit';
      options.hour12 = true;
      options.timeZoneName = format;
    }

    // Now format, showing our time with our timezone
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
}
